var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Rd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.64 14.64l3.48-2.53-3.53-4.85-3.48 2.53-3.32-4.58-35.09 25.5 3.48 4.78-3.29 2.42 3.56 4.84 3.26-2.4L30 44.91l22.28-16.17A19 19 0 0137 59a19.07 19.07 0 01-11.64-4H35v-4H10v4h9.58A23.08 23.08 0 0034 62.8V66H20v4h34v-4H40v-3.2a23 23 0 0015.51-36.41l9.6-7-3.47-4.75zM31 38.89l-5.26-7.23 28.1-20.43 5.25 7.24L31 38.89z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_R&D.2e6e923e.svg";
export { SvgK1Rd as ReactComponent };